import { render, staticRenderFns } from "./accountsReceivable.vue?vue&type=template&id=8a4536ce&scoped=true&"
import script from "./accountsReceivable.vue?vue&type=script&lang=js&"
export * from "./accountsReceivable.vue?vue&type=script&lang=js&"
import style0 from "./accountsReceivable.vue?vue&type=style&index=0&id=8a4536ce&prod&lang=scss&scoped=true&"
import style1 from "./accountsReceivable.vue?vue&type=style&index=1&id=8a4536ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4536ce",
  null
  
)

export default component.exports